import React, { useEffect, useState, useCallback } from "react";
import { Link } from "react-router-dom";
import {
    Form,
    Input,
    Select,
    Modal,
    Typography,
    Button,
    DatePicker,
    notification,
    TimePicker,
} from "antd";
import moment from "moment";
import dayjs from "dayjs";
import ProductionApi from "../../Apis/ProductionApi";
import HotHoldApi from "../../Apis/HotHoldApi";
import { AudioOutlined, InfoCircleFilled, LoadingOutlined } from "@ant-design/icons";
import StorageSelectHotHold from "../../DropDowns/HotHold/StorageSelectHotHold";
const { Title } = Typography;
function AddTemp({ visible, onClose, ProductctionDetails }) {
    const [formAdd] = Form.useForm();
    const decodedToken = JSON.parse(localStorage.getItem("decodedToken"));


    const [Product, setproducts] = React.useState([]);
    const getProduction = useCallback(() => {
        ProductionApi.ListProduction2()
            .then((response) => {
                setproducts(response?.payloadDto);
            })
            .catch((err) => {
                console.log(err);
            });
    }, []);

    const currentTime = moment().format("h:mm a");

    useEffect(() => {
        getProduction();
        const intervalID = setInterval(() => {
            setTime(new Date());
        }, 1000);
        if (ProductctionDetails) {
            formAdd.setFieldsValue({
                ProductionID: ProductctionDetails?.productionDTO?.id ?? ProductctionDetails?.id,
                institutionID: ProductctionDetails?.institutionDTO?.id,
                storageUnit: ProductctionDetails?.storageDTO?.id,
                createDate: dayjs(ProductctionDetails.hotHoldDate),
                createTime: dayjs(ProductctionDetails.hotHoldTime),
            });
        }
    }, [getProduction, ProductctionDetails]);

    const [ProductionDetails, setProductionDetails] = React.useState([]);
    // console.log("ProductctionDetails", ProductionDetails);
    const handleChangeProduct = (value) => {
        ProductionApi.SingleProduction(value)
            .then((response) => {
                console.log(response?.payload)
                formAdd.setFieldsValue({
                    institutionID: response?.payload?.institutionDTO?.id,
                });
                setProductionDetails(response?.payload)
            })
            .catch((err) => {
                console.log(err);
            });

    };
    function convertTo12HourFormat(timeString) {
        const [hours, minutes] = timeString.split(':').map(Number);
        const amOrPm = hours >= 12 ? 'PM' : 'AM';
        const formattedHours = (hours % 12 || 12).toString().padStart(2, '0');
        const formattedMinutes = minutes.toString().padStart(2, '0');
        return `${formattedHours}:${formattedMinutes} ${amOrPm}`;
    }
    function formatDate(date) {
        const dateNew = parseInt(date, 10);
        const options = { day: "2-digit", month: "short", year: "numeric" };
        const formattedDate = new Date(dateNew).toLocaleDateString(
            "en-US",
            options
        );

        const [month, day, year] = formattedDate.split(" ");
        const capitalizedMonth = month.toUpperCase();
        return `${day} ${capitalizedMonth} ${year}`;
    }
    const [Correctvalid, setCorrectvalid] = useState(false);
    const handleInputChange = (event) => {
        const newItem = event.target.value.trim();
        if (parseInt(newItem) < 63) {
            setCorrectvalid(true)
        } else {
            setCorrectvalid(false)
        }

    };
    const [time, setTime] = useState(new Date());
    const formattedTimeNew = time.toLocaleTimeString();

    const handleSubmit = (data) => {


        const SelectDate = dayjs(data.createDate).format("DD/MM/YYYY");
        const createTime = dayjs(data.createTime).format("h:mm a");
        let formData = JSON.stringify({
            hotHoldTime: convertToUnixTimestamp(createTime),
            hotHoldDate: convertToUnixTimestamp(SelectDate),
            temp: data.Temperature,
            storageUnit: data.storageUnit,
            correctiveAction: Correctvalid ? data.correctiveAction : "N/A",
            productionDTO: {
                id: data?.ProductionID,
            },
            storageDTO: {
                id: data?.storageUnit,
            },
            tenantDTO: {
                id: decodedToken?.tenantId,
                tenantApiKey: decodedToken?.tenantApiKey,
            },
            institutionDTO: {
                id: data.institutionID,
            },
        });
        HotHoldApi.CreatehotHold(formData)
            .then((response) => {
                notification.open({
                    message: <span style={{ fontWeight: "bold" }}>Created</span>,
                    description: "Created Successfully",
                    closeIcon: false,
                    duration: 3,
                    style: {
                        backgroundColor: "#b3ffb3",
                        color: "green",
                    },
                });
                setTimeout(() => {
                    window.location.reload();
                }, 500);
            })
            .catch((err) => {
                console.log(err);
                // Error Notification
                if (err.apiError.status) {
                    notification.open({
                        message: (
                            <span style={{ fontWeight: "bold" }}>{err.apiError.status}</span>
                        ),
                        description: err.apiError.message,
                        closeIcon: false,
                        duration: 3,
                        style: {
                            backgroundColor: "#fff2f0",
                            color: "red",
                        },
                    });
                }
            });

    };
    function convertToUnixTimestamp(dateString) {
        const parts = dateString.split("/");
        const day = parseInt(parts[0], 10);
        const month = parseInt(parts[1], 10) - 1;
        const year = parseInt(parts[2], 10);

        const unixTimestamp = Date.UTC(year, month, day);
        return unixTimestamp;
    }
    const currentDate = moment().format("DD/MM/YYYY");

    const handleCancel = () => {
        formAdd.resetFields();

        onClose();
    };
    const handleInput = (e) => {
        const value = e.target.value;
        if (/^\d*\.?\d{0,2}$/.test(value)) {
            e.target.value = value;
        } else {
            // Remove any non-numeric or extra decimal characters
            e.target.value = value.slice(0, -1);
        }
    };

    const [isRecording, setIsRecording] = useState(false);
    const startRecording = (fieldN) => {

        const recognition = new window.webkitSpeechRecognition();
        recognition.lang = 'en-US';
        recognition.onresult = (event) => {
            const transcript = event.results[0][0].transcript;
            let fieldName = fieldN;

            formAdd.setFieldsValue({
                [fieldName]: transcript,
            });
        };

        recognition.start();
        if (fieldN === 'Temperature') {
            setIsRecording(true);
        }
    };

    const stopRecording = () => {
        setIsRecording(false);
    };
    return (
        <>
            <Modal
                footer={[]}
                width={600}
                visible={visible}
                maskClosable={false}
                onCancel={handleCancel}
                onOk={onClose}
            >
                <Title level={4} className="text-center Primary-Font mb-4 pb-3">
                    Add to Hot Hold
                </Title>
                <Form
                    form={formAdd}
                    name="nest-messages"
                    layout="horizontal"
                    labelCol={{
                        span: 9,
                    }}
                    wrapperCol={{
                        span: 15,
                    }}
                    className="FormClass SlectNew IndividualProduct-Model"
                    onFinish={handleSubmit}
                >
                    <>
                        <div className="Product-createDate">
                            <div className="my-3" style={{ display: 'flex', fontSize: '18px', alignItems: 'center' }}>
                                <b className="mx-2">{currentDate}</b>
                                <img
                                    src="/assest/Images/cal.png"
                                    style={{ width: '32px' }}
                                    className="logo-png"
                                />
                            </div>
                            <div className="px-2" style={{ display: 'flex', fontSize: '18px', alignItems: 'center' }}>
                                <b>{formattedTimeNew}</b> <img
                                    src="/assest/Images/time.png"
                                    style={{ width: '35px', marginLeft: '10px' }}
                                    className="logo-png"
                                />

                            </div>
                            <Form.Item
                                name="createDate"
                                initialValue={dayjs(currentDate, "DD/MM/YYYY")}
                                className="text-lable col-lg-6 col-sm-12 col-md-7 disabled d-none"
                                rules={[
                                    {
                                        required: true,
                                        message: "Please enter Date.",
                                    },
                                ]}
                            >
                                <DatePicker
                                    disabled
                                    format={"DD/MM/YYYY"}
                                    className="form-control control-input"
                                />
                            </Form.Item>
                        </div><div className="Product-createDate">
                            <Form.Item
                                name="createTime"
                                initialValue={dayjs(currentTime, "h:mm a")}
                                className="text-lable col-lg-6 col-sm-12 col-md-7 disabled d-none"
                                rules={[
                                    {
                                        required: true,
                                        message: "Please enter Date.",
                                    },
                                ]}
                            >
                                <TimePicker disabled use12Hours format="h:mm a" className="form-control control-input" />

                            </Form.Item>
                        </div>
                        <StorageSelectHotHold valid={ProductctionDetails?.productionDTO ? true : false} />
                        <Form.Item
                            name="ProductionID"
                            label="Product Description"
                            className={ProductctionDetails ? 'text-lable mt-3 disabled' : 'text-lable mt-3'}
                            rules={[
                                {
                                    required: true,
                                    message: "Please Select Production.",
                                },
                            ]}
                        >
                            <Select
                                disabled={ProductctionDetails ? true : false}
                                className="control-Select mb-3 "
                                placeholder="Select Production"
                                id="ProductionID"
                                dropdownRender={(menu) => (
                                    <div>
                                        <div style={{ padding: '8px', borderBottom: '1px solid #f0f0f0', justifyContent: 'space-around', display: 'flex', textAlign: 'start' }}>
                                            <b>Batch Code</b> | <b>Name</b>
                                        </div>
                                        {menu}
                                    </div>
                                )}
                                onChange={(value) => handleChangeProduct(value)}
                            >
                                {Product && (
                                    <>
                                        {Product?.map((option, index) => (
                                            <Select.Option key={index} value={option?.id} style={{ borderBottom: '1px solid #f0f0f0', justifyContent: 'space-around', display: 'flex', textAlign: 'start' }}>
                                                <div style={{ padding: '4px', justifyContent: 'space-between', alignItems: 'center', display: 'flex', textAlign: 'start' }}>
                                                    <span style={{ lineHeight: '20px' }}>{`${option?.batchCode}`}<br /><label style={{ fontSize: '12px', color: 'gray' }}>{`${formatDate(option?.productionCreateDate)}`}&nbsp;&nbsp;{`${convertTo12HourFormat(option?.cookingTime)}`}</label></span>
                                                    <span>{`${option?.recipeDTO?.recipeName}`}</span>
                                                </div>
                                            </Select.Option>
                                        ))}
                                    </>
                                )}
                            </Select>
                        </Form.Item>


                        <Form.Item
                            name="Temperature"
                            label="Temperature"
                            className="text-lable"
                            rules={[
                                {
                                    required: true,
                                    message: "Please enter Temperature.",
                                },
                            ]}
                        >
                            <Input
                                type="number"
                                onChange={(event) => handleInputChange(event)}
                                placeholder="0"
                                className="control-input col-6"
                                style={{
                                    border: 'none',
                                    textAlign: 'end',
                                    padding: '0px'
                                }}
                                addonAfter={
                                    <>
                                        <Button
                                            className="StockTempClass"
                                            style={{
                                                border: 'none',
                                                padding: 0,
                                                paddingTop: '0px',
                                                margin: 0,
                                                background: 'none',
                                                cursor: 'pointer',
                                            }}
                                        >
                                            'C
                                        </Button>
                                        <Button
                                            onMouseDown={() => startRecording('Temperature')}
                                            onMouseUp={stopRecording}
                                            onMouseLeave={stopRecording}
                                            style={{
                                                border: 'none',
                                                padding: 0,
                                                margin: 0,
                                                marginLeft: '10px',
                                                paddingLeft: '5px',
                                                paddingBottom: '5px',
                                                background: 'none',
                                                borderRadius: '0px',
                                                borderLeft: '1px solid #d9d9d9',
                                                cursor: 'pointer',
                                            }}
                                        >
                                            {isRecording ? <LoadingOutlined /> : <AudioOutlined />}
                                        </Button>
                                    </>
                                }
                            />
                        </Form.Item>
                        <Form.Item
                            name="institutionID"
                            label="institutionID"
                            className="text-lable d-none"
                            rules={[
                                {
                                    required: true,
                                    message: "Please Select Institution.",
                                },
                            ]}
                        >
                            <Input
                                type="text"
                                onInput={handleInput}
                                placeholder="Temperature"
                                className="control-input"
                            />
                        </Form.Item>
                        <p style={{ textAlign: 'center', fontSize: '13px', color: 'blue' }}  ><InfoCircleFilled style={{ fontSize: '9px' }} className="inforIcon" /> Temperature should be 63℃ and above</p>

                        <Form.Item
                            name="correctiveAction"
                            label="Corrective Action"
                            className={Correctvalid ? 'text-lable' : 'd-none'}
                            rules={Correctvalid ? [
                                {
                                    required: true,
                                    message: "Please enter Temperature.",
                                },
                            ] : []}
                        >
                            <Input
                                type="text"
                                placeholder="Corrective Action"
                                className="control-input"
                            />
                        </Form.Item>





                        <div className="d-flex justify-content-center pt-4">
                            <Button
                                type="primary"
                                htmlType="submit"
                                className="btn btn-primary btn-save mx-2"
                                style={{ width: "37%" }}
                            >
                                Create
                            </Button>
                            <Link
                                type="primary"
                                to={""}
                                className="btn btn-primary btn-back mx-2 w-20"
                                style={{ width: "37%" }}
                                onClick={handleCancel}
                            >
                                Cancel
                            </Link>
                        </div>
                    </>
                </Form>
            </Modal>
        </>
    );
}

export default AddTemp;